// homeHeroVideo.js
// Ensures the hero video plays after a Barba transition

export function playHomeHeroVideo(container = document) {
  const video = container.querySelector('.dpage-hero-video__media video');
  if (video) {
    // Try to play the video if it's paused
    if (video.paused) {
      // Some browsers require play() to be called in a user gesture context
      video.play().catch(() => {
        // Optionally, handle play errors (autoplay policy, etc)
      });
    }
  }
}
